import React from 'react';
import { Header, Heading, HeadingGroup } from 'rsuite';

// Define the PageHeader component
interface PageHeaderProps {
  title: string;
  children?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, children }) => {
  return (
    <Header>
      <HeadingGroup>
        <Heading level={4}>{title}</Heading>
        {children}
      </HeadingGroup>
    </Header>
  );
};

export default PageHeader;